import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Money from 'common/components/money';
import Bundles from 'project/containers/wrapup/bundles';
import MessageTimeline from 'common/containers/message_timeline';
import IncreaseAwardButton from 'project/containers/wrapup/increase_award_button';
import SignContract from 'project/containers/wrapup/sign_contract';

const APPROVE_DESCR = (
  <div>
    <p>
      Make sure your proofs reflect exactly what you want in the final design. If you still have
      a few tweaks, click "Cancel" below and ask the designer to make them before you approve.
    </p>
    <p>After you approve the proofs, the designer will create and upload final files.</p>
  </div>
);

const APPROVE_DISCLAIMER = "Do not approve your proofs unless you are happy with them. If you need changes, ask the designer to make them.";

export default class Proofs extends Component {
  componentDidMount() {
    const { wrapup, fetchMessagesIfNeeded } = this.props;

    fetchMessagesIfNeeded({
      streamId: wrapup.proof_message_stream,
      wrapupStep: 'approve_proofs',
      wrapup
    });
  }

  renderHeader() {
    const { isCreative, isAdmin, wrapup } = this.props;

    let title, description;

    if (isAdmin) {
      title = <h3>
        Proofs for Award { wrapup.award.position }
        <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
      </h3>;

    /* TODO: REMOVE THIS IF BLOCK ONCE WE NO LONGER HAVE LEGACY WRAP-UPS */
    } else if (!isCreative && !wrapup.contract.client_signature_created_at) {
      title = <h3>
        Contract and proofs for Award { wrapup.award.position }
        <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
      </h3>;

      description = <p>
        The contract protects both you and the creative. It ensures you own the creative's work
        and are legally protected.
      </p>;
    } else if (isCreative) {
      title = <h3>
        Proofs for Award { wrapup.award.position }
        <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
      </h3>;

      /* contract not yet signed */
      if (!wrapup.contract.creative_signature_created_at) {
        title = <h3>
          Contract and proofs for Award { wrapup.award.position }
          <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
        </h3>;

        description = <p>
          The contract protects both you and the client. It ensures you are
          compensated for your work and are legally protected. We'll email
          you a signed copy of the contract after you sign it.
        </p>;
      /* contract signed, but no proofs uploaded */
      } else if (wrapup.proof_bundles.length === 0) {
        description = <p>
          We emailed you a <Link target="_blank" to={wrapup.contract.pdf_signed}>signed copy
          of the project contract</Link>. <br/>
          Remember this step is just for proofs. Send a JPG, PNG or PDF file of the proof
          sheet. Be sure to include any information the client may need about fonts and colors
          and provide liks to any stock images the client will need to purchase.
        </p>;
      /* proofs uploaded, but not yet approved */
      } else if (!wrapup.proofs_approved_at) {
        description = <p>
          Now that you've sent proofs, please be patient. It may take the client a few days
          to review the proofs and approve them. They'll let you know if they require any
          changes.
        </p>;
      /* proofs approved */
      } else {
        description = <p>
          Your proofs have been approved.
        </p>;
      }
    } else {
      title = <h3>
        Review and approve proofs for Award { wrapup.award.position }
        <span className="award-value"> (<Money value={wrapup.award.value} />)</span>
        <IncreaseAwardButton />
      </h3>;

      /* no proofs uploaded */
      if (wrapup.proof_bundles.length === 0) {
        description = <p>
          We'll email you a signed copy of the contract when { wrapup.creative.username } signs
          it.
        </p>;
      /* proofs uploaded, but not yet approved */
      } else if (!wrapup.proofs_approved_at) {
        description = <p>
          Your proofs are ready! Download them below. If you're happy with the proofs,
          click the green "Approve proofs and move to next step" button. Your designer
          will upload all the final files in all the required formats after you approve
          the proofs.
        </p>;
      /* proofs approved */
      } else {
        description = <p>
          Proofs have been approved.
        </p>;
      }
    }

    return (
      <div className="row">
        <div className="small-16 large-14 columns">
          <header className="step-header">
            { title }
            { description }
          </header>
        </div>
      </div>
    );
  }

  renderContent() {
    const {
      isCreative, wrapup, details, itemsToUpload, approveChecklist, prepopulatedMsgOpts
    } = this.props;

    /* TODO: REMOVE THIS IF BLOCK ONCE WE NO LONGER HAVE LEGACY WRAP-UPS */
    if (!isCreative && !wrapup.contract.client_signature_created_at) {
      return (
        <div className="row">
          <div className="columns small-16">
            <h5 className="text-danger">
              You have not signed the contract. You cannot<br className="hide-for-small-only"/>
              {' '}approve proofs until you sign the contract.
            </h5>
            <SignContract wrapup={wrapup} signingAs="client" />
          </div>
        </div>
      );
    }

    /* contract not yet signed (creative view) */
    if (isCreative && !wrapup.contract.creative_signature_created_at) {
      return (
        <div className="row">
          <div className="columns small-16">
            <h5 className="text-danger">
              You have not signed the contract. You cannot<br className="hide-for-small-only"/>
              {' '}upload proofs until you sign the contract.
            </h5>
            <SignContract wrapup={wrapup} />
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="row">
          <div className="columns medium-4 small-16">
            <h3>Files</h3>
          </div>
          <div className="columns medium-12 small-16">
            <Bundles wrapup={wrapup} bundles={wrapup.proof_bundles}
              name="proofs" approveDescr={APPROVE_DESCR} approveChecklist={approveChecklist}
              approvedAt={wrapup.proofs_approved_at} itemsToUpload={itemsToUpload}
              collaboratorApprovePerm="approve_proofs"
              approveDisclaimer={APPROVE_DISCLAIMER} />
          </div>
        </div>
        <div className="row">
          <div className="columns medium-4 small-16">
            <h3>Messages</h3>
          </div>
          <div className="columns medium-12 small-16">
            <MessageTimeline wrapup={wrapup} canPost={details.available} canAttach={!isCreative}
              canReply={false} editorActionLabel="Send this message" wrapupStep="approve_proofs"
              editorPrepopulatedOpts={prepopulatedMsgOpts} canPostInternal={!isCreative}/>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="wrapup-step proofs">
        { this.renderHeader() }

        { this.renderContent() }
      </div>
    );
  }
}

Proofs.propTypes = {
  wrapup: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  fetchMessagesIfNeeded: PropTypes.func.isRequired,
  isCreative: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  itemsToUpload: PropTypes.string,
  approveChecklist: PropTypes.string,
  prepopulatedMsgOpts: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./project/components/wrapup/proofs.jsx